namespace GeniuzPOS.AdvPromo {
    export interface PsPromoAvShopForm {
        PmGroupId: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
    }

    export class PsPromoAvShopForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsPromoAvShop';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPromoAvShopForm.init)  {
                PsPromoAvShopForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsPromoAvShopForm, [
                    'PmGroupId', w0,
                    'ShopId', w0
                ]);
            }
        }
    }
}
